// extracted by css-extract-rspack-plugin
export default {"cls1":"FallbackBulkDownloadUpsellModalControl-cls1_KP6","cls2":"FallbackBulkDownloadUpsellModalControl-cls2_te_ FallbackBulkDownloadUpsellModalControl-cls1_KP6"};